import { render, staticRenderFns } from "./OnOff.vue?vue&type=template&id=5dcb1683"
import script from "./OnOff.vue?vue&type=script&lang=js"
export * from "./OnOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports